/* eslint-disable prefer-promise-reject-errors */
import store from '@/store'
import router from '@/router'

export default {
  canActivate() {
    return new Promise((resolve, reject) => (store.state.auth.token ? resolve() : router.replace('/') && reject()))
  }
}
